import moment from "moment";
import PropTypes from "prop-types";
import React from "react";

import ToBack from "../../components/ToBack";
import { DateTitle, JournalTabs } from "../Components";

const DataRow = ({ address, dtime, ip }) => (
  <>
    <div className="row">
      <div className="col">
        <div className="pull-left">
          <strong>{address}</strong>
        </div>
        <div className="pull-right text-muted" style={{ fontSize: 11 }}>
          {moment(dtime).format("YYYY-MM-DD HH:mm")}
        </div>
        <br />
        <span className="pull-left text-muted">{ip}</span>
      </div>
    </div>
    <hr style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }} />
  </>
);

DataRow.propTypes = {
  address: PropTypes.string,
  dtime: PropTypes.string.isRequired,
  ip: PropTypes.string,
};

DataRow.defaultValue = {
  address: "",
  ip: "0.0.0.0",
};

const LoginJournal = () => {
  const [list, setList] = React.useState({});
  const auth = JSON.parse(localStorage.getItem("auth"));

  React.useEffect(() => {
    if (auth === null) return;
    const url = [
      "/api/miscellaneous/journal",
      "?option=by-ref_id-category-tag",
      `&ref_id=${auth.id}`,
      "&category=登录",
      "&tag=个人用户",
    ];
    fetch(url.join(""))
      .then((response) => response.json())
      .then((data) => {
        const r = {};
        const today = moment().format("YYYY-MM-DD");
        data.forEach((current) => {
          let date = moment(current.dtime).format("YYYY-MM-DD");
          if (today === date) {
            date = "今天";
          }
          if (r[date]) {
            r[date].push(current);
          } else {
            r[date] = [current];
          }
        });
        setList(r);
      });
  }, []);

  return (
    <>
      {auth === 0 ? (
        <div className="container-fluid">
          <ToBack category="操作记录" href="#我的" />
          <div className="chat-login">
            <h6>登录后可以查看操作记录</h6>
            <button
              type="button"
              style={{ width: "25%" }}
              className="btn btn-block mx-auto rounded-pill button-background text-white font-weight"
              onClick={() => {
                location.href = "#/登录";
              }}
            >
              登&nbsp;录
            </button>
          </div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="card mt-2">
            <ToBack category="操作记录" href="#我的" />
            <JournalTabs category="登录" />
            <div className="card-body">
              <div className="tab-content">
                <div className="tab-pane fade show active">
                  {Object.getOwnPropertyNames(list).map((key) => (
                    <React.Fragment key={key}>
                      <DateTitle text={key} />
                      <div className="mt-2" />
                      {list[key].map((item) => (
                        <DataRow key={item.id} {...item} />
                      ))}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LoginJournal;
